import { SDBN_WALLET_ROUTES } from "@coimbra-its/api.sdbn.wallet";
import { WSysApi } from "@coimbra-its/websys-ux-core";
import { createContext, useContext } from "react";



export const Sdbn2Api = createContext(new WSysApi(process.env.REACT_APP_API_BASE_URL + '' || '', SDBN_WALLET_ROUTES,
  headers => {
      /*const sessionId = useSessionId();
      (headers as any)['authorization'] = `Bearer ${sessionId}`;*/
  }
));

export type TSdbn2Api = typeof Sdbn2Api;


export function useSdbn2Api() {
  const api = useContext(Sdbn2Api);
  return api.ep;
}